import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';

import { NoLayout } from '@/components/layouts/index.tsx';
import PageLoading from '@/components/loading/PageLoading.tsx';

const OauthRedirect = () => {
  const navigate = useNavigate();
  const once = useRef(false);

  useEffect(() => {
    if (!once.current) {
      once.current = true;
      void navigate({ to: '/', replace: true });
    }
  }, [navigate]);

  return <PageLoading />;
};

// biome-ignore lint/style/useComponentExportOnlyModules: tanstack route
export const Route = createFileRoute('/oauth-redirect')({
  component: () => (
    <NoLayout title="shared.navigation.login_flow">
      <OauthRedirect />
    </NoLayout>
  ),
});
